import { Pagination } from "services/search";

import {
  VehicleManufacturer,
  VehicleManufacturerRow,
} from "./types";

import { DataWithPagination } from "services/api/types";
import {
  transformVehicleManufacturer,
  transformVehicleManufacturerRow,
} from "./transformations";
import { createApiCall, paginatedApiCall } from "services/api/createApiCall";
import { transformErrorResponse } from "services/api/transformation";

/*---------------------------------------------------------------------------------------
  SEARCH
-----------------------------------------------------------------------------------------*/
export const getVehicleManufacturersAPI = async (
  pagination: Pagination,
  name?: string | null,
  vehicleCategoryId?: string | null
): Promise<DataWithPagination<VehicleManufacturerRow>> => {
  let path = `/v1/catalog/vehicles/manufacturers?name=`;

  if (name) path += `${name}`;
  if (vehicleCategoryId) path += `&vehicleCategoryId=${vehicleCategoryId}`;

  return await paginatedApiCall(
    path,
    pagination,
    transformVehicleManufacturerRow
  );
};

/*---------------------------------------------------------------------------------------
    INFO
  -----------------------------------------------------------------------------------------*/
export const getVehicleManufacturerAPI = async (
  id: string
): Promise<VehicleManufacturer> => {
  const response = await createApiCall(
    {
      path: `/v1/catalog/vehicles/manufacturers/${id}`,
      method: "GET",
    },
    {
      getMessage: {
        // `error.response.data.message` bi puknuo na mrežnoj grešci i ispisao „undefined" na
        // odgovorima koji nose `errors` umjesto `message`.
        error: (error: any) => `${transformErrorResponse(error)}`,
      },
    }
  )();

  return transformVehicleManufacturer(response.data);
};

